<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      title="资料提供"
      width="65%"
    >
      <!-- 表单：包含验证规则 -->
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <!-- 姓名输入 -->
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名" />
        </el-form-item>
        <!-- 手机号输入 -->
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" />
        </el-form-item>
        <!-- 身份证号输入 -->
        <el-form-item label="身份证号" prop="idCard">
          <el-input v-model="form.idCard" placeholder="请输入身份证号" />
        </el-form-item>

        <!-- 上传区域：用栅格布局排列6个上传项 -->
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="身份证正面" prop="idCardZm">
              <el-upload
                v-model="form.idCardZm"
                :action="$imgHost"
                :auto-upload="true"
                :before-upload="beforeUpload"
                :class="{ 'hide-upload-button': form.idCardZmList.length > 0 }"
                :file-list="form.idCardZmList"
                :limit="1"
                :on-exceed="handleExceed"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove('idCardZm')"
                :on-success="handleSuccess('idCardZm')"
                list-type="picture-card"
              >
                <!-- 上传成功后隐藏上传按钮 -->
                <div v-if="form.idCardZmList.length === 0" class="upload-btn">
                  <img height="50" src="@/assets/images/sfzzm.png" />
                  <div class="upload-text">点击上传</div>
                  <div class="upload-text">身份证正面</div>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="身份证反面" prop="idCardFm">
              <el-upload
                v-model="form.idCardFm"
                :action="$imgHost"
                :auto-upload="true"
                :before-upload="beforeUpload"
                :class="{ 'hide-upload-button': form.idCardFmList.length > 0 }"
                :file-list="form.idCardFmList"
                :limit="1"
                :on-exceed="handleExceed"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove('idCardFm')"
                :on-success="handleSuccess('idCardFm')"
                list-type="picture-card"
              >
                <div v-if="form.idCardFmList.length === 0" class="upload-btn">
                  <img height="50" src="@/assets/images/sfzfm.png" />
                  <div class="upload-text">点击上传</div>
                  <div class="upload-text">身份证反面</div>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="在职证明" prop="zzzm">
              <el-upload
                v-model="form.zzzm"
                :action="$imgHost"
                :before-upload="beforeUpload"
                :class="{ 'hide-upload-button': form.zzzmList.length > 0 }"
                :file-list="form.zzzmList"
                :limit="1"
                :on-exceed="handleExceed"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove('zzzm')"
                :on-success="handleSuccess('zzzm')"
                list-type="picture-card"
              >
                <div v-if="form.zzzmList.length === 0" class="upload-btn">
                  <img height="50" src="@/assets/images/zzzm.png" />
                  <div class="upload-text">点击上传</div>
                  <div class="upload-text">在职证明</div>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="社保证明" prop="sbzm">
              <el-upload
                v-model="form.sbzm"
                :action="$imgHost"
                :before-upload="beforeUpload"
                :class="{ 'hide-upload-button': form.sbzmList.length > 0 }"
                :file-list="form.sbzmList"
                :limit="1"
                :on-exceed="handleExceed"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove('sbzm')"
                :on-success="handleSuccess('sbzm')"
                list-type="picture-card"
              >
                <div v-if="form.sbzmList.length === 0" class="upload-btn">
                  <img height="50" src="@/assets/images/sbzm.jpg" />
                  <div class="upload-text">点击上传</div>
                  <div class="upload-text">社保证明</div>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="一寸照片" prop="photo">
              <el-upload
                v-model="form.photo"
                :action="$imgHost"
                :before-upload="beforeUpload"
                :class="{ 'hide-upload-button': form.photoList.length > 0 }"
                :file-list="form.photoList"
                :limit="1"
                :on-exceed="handleExceed"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove('photo')"
                :on-success="handleSuccess('photo')"
                list-type="picture-card"
              >
                <div v-if="form.photoList.length === 0" class="upload-btn">
                  <img height="50" src="@/assets/images/ycz.png" />
                  <div class="upload-text">点击上传</div>
                  <div class="upload-text">一寸照片</div>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="毕业证书" prop="byz">
              <el-upload
                v-model="form.byz"
                :action="$imgHost"
                :before-upload="beforeUpload"
                :class="{ 'hide-upload-button': form.byzList.length > 0 }"
                :file-list="form.byzList"
                :limit="1"
                :on-exceed="handleExceed"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove('byz')"
                :on-success="handleSuccess('byz')"
                list-type="picture-card"
              >
                <div v-if="form.byzList.length === 0" class="upload-btn">
                  <img height="50" src="@/assets/images/byzs.jpg" />
                  <div class="upload-text">点击上传</div>
                  <div class="upload-text">毕业证书</div>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 预览弹窗 -->
        <el-dialog
          :visible.sync="dialogVisibleImg"
          append-to-body
          title="预览"
          width="800px"
        >
          <img :src="dialogImageUrl" alt="预览图" class="preview-img" />
        </el-dialog>
        <!-- 审核状态 -->
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item v-if="form.status" label="审核状态" prop="status">
              {{
                form.status
                  ? shList.find((item) => item.value == form.status).label
                  : ""
              }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              v-if="form.rejectcd"
              label="审核不通过原因"
              prop="rejectcd"
            >
              {{
                form.rejectcd
                  ? rejectcd.find((item) => item.value == form.rejectcd).label
                  : ""
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 温馨提示 -->
        <el-form-item>
          <div class="tip-text">
            温馨提示：上传的图片格式为jpg或png，图片大小为2M内。<br />
            该上传资料用于考试报名审核，请您务必保证上传资料真实有效。
          </div>
        </el-form-item>

        <!-- 确认提交按钮 -->
        <el-form-item>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">提 交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { cyryAddApi, cyryUpdateApi } from "@/api/home";

export default {
  name: "DataSubmissionDialog",
  props: {
    shList: {
      type: Array,
      default: () => [],
    },
    rejectcd: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: false, // 弹窗显示状态
      dialogVisibleImg: false,
      dialogImageUrl: "",
      form: {
        shid: "",
        reviewId: "",
        name: "",
        idCard: "",
        phone: "",
        idCardZm: "",
        idCardFm: "",
        byz: "",
        sbzm: "",
        photo: "",
        zzzm: "",
        status: "", // 审核状态
        rejectcd: "", //
        idCardZmList: [], // 身份证正面上传列表
        idCardFmList: [], // 身份证反面上传列表
        zzzmList: [], // 在职证明上传列表
        sbzmList: [], // 社保证明上传列表
        photoList: [], // 一寸照片上传列表
        byzList: [], // 毕业证书上传列表
      },
      // 表单验证规则
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号格式",
            trigger: "blur",
          },
        ],
        idCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "身份证号格式不正确",
            trigger: "blur",
          },
        ],
        unitName: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        idCardZm: [
          { required: true, message: "请上传身份证正面", trigger: "change" },
        ],
        idCardFm: [
          { required: true, message: "请上传身份证反面", trigger: "change" },
        ],
        zzzm: [
          { required: true, message: "请上传在职证明", trigger: "change" },
        ],
        sbzm: [
          { required: true, message: "请上传社保证明", trigger: "change" },
        ],
        photo: [
          { required: true, message: "请上传一寸照片", trigger: "change" },
        ],
        byz: [{ required: true, message: "请上传毕业证书", trigger: "change" }],
      },
    };
  },
  methods: {
    setData(row) {
      // 表格数据
      console.log(row, "setData");
      // 1. 基础信息回显
      this.form.name = row.name || "";
      this.form.phone = row.phone || "";
      this.form.idCard = row.idCard || "";
      this.form.shid = row.shid || "";
      this.form.reviewId = row.shid || "";
      this.form.status = row.status || "";
      this.form.rejectcd = row.rejectcd || "";

      // 2. 图片数据回显（处理上传组件的fileList）
      const imageFields = [
        "idCardZm",
        "idCardFm",
        "zzzm",
        "sbzm",
        "photo",
        "byz",
      ];

      imageFields.forEach((field) => {
        // 设置图片路径
        this.form[field] = row[field] || "";
        // 构建上传组件需要的fileList格式
        if (row[field]) {
          this.form[`${field}List`] = [
            {
              name: this.getFileName(row[field]), // 提取文件名
              url: this.getImageUrl(row[field]), // 构建完整图片URL
              // 标记为已上传文件（用于区分新增文件）
              status: "success",
            },
          ];
        } else {
          this.form[`${field}List`] = [];
        }
      });
    },
    // 辅助方法：从路径中提取文件名
    getFileName(path) {
      if (!path) return "";
      return path.split("/").pop();
    },

    // 辅助方法：构建完整图片URL
    getImageUrl(path) {
      if (!path) return "";
      // 判断路径是否已包含完整域名
      if (path.startsWith("http://") || path.startsWith("https://")) {
        return path;
      }
      // 拼接图片服务器地址（使用上传时的host）
      let token = this.$Cookies.get("xh_userInfo")
        ? JSON.parse(this.$Cookies.get("xh_userInfo")).token
        : "";

      return (
        this.$previewImg +
        (this.$previewImg.endsWith("/") ? "" : "/") +
        path +
        "?token=" +
        token
      );
    },
    // 通用上传成功处理
    handleSuccess(key) {
      console.log("key-handleSuccess", key);
      console.log("this.form", this.form);

      return (response, file, fileList) => {
        this.form[key] = response.result.file.filefullpath;
        this.form[`${key}List`] = fileList;
        console.log(`【${key}】上传成功`, response, file);
      };
    },

    // 处理文件超出数量限制
    handleExceed(files, fileList) {
      this.$message.warning(
        `仅支持上传1个文件，本次选择了${files.length}个，已过滤多余文件`,
      );
    },

    // 通用上传前验证
    beforeUpload(file) {
      console.log("beforeUpload", file);
      const { name, size } = file;
      // 文件类型限制
      const fileTypeFlag = /^.png|.jpg|.jpeg$/.test(
        name.substring(name.lastIndexOf(".")).toLowerCase(),
      );
      if (!fileTypeFlag) {
        this.$message({
          message: "文件类型只能是.png|.jpg|.jpeg",
          type: "warning",
          duration: "5000",
        });
        return false;
      }
      // 文件大小限制
      if (size > 1024 * 1024 * 2) {
        this.$message.warning("文件大小不能超过2Mb");
        return false;
      }
    },

    // 通用删除处理
    handleRemove(key) {
      return (file, fileList) => {
        console.log(`【${key}】删除文件`, file, fileList);
        this.form[key] = "";
        this.form[`${key}List`] = fileList;
      };
    },

    // 预览图片
    handlePictureCardPreview(file) {
      console.log("file", file);
      this.dialogImageUrl =
        file.url || file.response?.result?.file?.filefullpath;
      this.dialogVisibleImg = true;
    },

    // 提交表单
    submitForm() {
      this.$refs.form.validate((isValid) => {
        if (isValid) {
          // 额外检查：所有上传项是否都有文件
          const isAllUploaded =
            this.form.idCardZmList.length &&
            this.form.idCardFmList.length &&
            this.form.zzzmList.length &&
            this.form.sbzmList.length &&
            this.form.photoList.length &&
            this.form.byzList.length;

          if (isAllUploaded) {
            // 提交表单到后端
            console.log("表单数据提交：", this.form);
            let params = {
              name: this.form.name,
              phone: this.form.phone,
              idCard: this.form.idCard,
              idCardZm: this.form.idCardZm,
              idCardFm: this.form.idCardFm,
              zzzm: this.form.zzzm,
              sbzm: this.form.sbzm,
              photo: this.form.photo,
              byz: this.form.byz,
              reviewId: this.form.reviewId,
            };
            this.$confirm(
              "本人郑重承诺所提交的信息和各项材料真实、准确、有效;如有虚假、错误信息和弄虚作假行为，一切后果由本人承担。",
              "资料真实承诺书",
              {
                confirmButtonText: "我已阅读并同意",
                cancelButtonText: "不同意",
                type: "warning",
              },
            )
              .then(() => {
                if (this.form.shid) {
                  cyryUpdateApi(params)
                    .then((res) => {
                      if (res.code === 200) {
                        this.$message.success("资料修改成功！");
                        this.dialogVisible = false; // 关闭弹窗
                        this.$emit("success");
                      }
                    })
                    .catch((err) => {
                      console.log("err", err);
                      this.$message.error("资料提交失败！");
                    });
                } else {
                  cyryAddApi(params)
                    .then((res) => {
                      if (res.code === 200) {
                        this.$message.success("资料提交成功！");
                        this.dialogVisible = false; // 关闭弹窗
                        setTimeout(() => {
                          this.$emit("success");
                        }, 3000);
                      }
                    })
                    .catch((err) => {
                      console.log("err", err);
                      this.$message.error("资料提交失败！");
                    });
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
          } else {
            this.$message.warning("请完成所有资料上传后再提交～");
          }
        } else {
          this.$message.warning("表单验证失败，请检查必填项～");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .hide-upload-button {
  width: 148px;
  height: 148px;

  .el-upload--picture-card {
    width: 148px;
    height: 148px;
    display: none !important;
  }
}

/* 上传区域样式 */
.upload-box {
  border: 1px dashed #dcdcdc;
  border-radius: 4px;
  text-align: center;
  padding: 20px;
  cursor: pointer;
}

/* 已上传文件样式 */
.uploaded-file {
  position: relative;
  width: 148px;
  height: 148px;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
}

.uploaded-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.delete-icon {
  position: absolute;
  right: 5px;
  top: 5px;
  color: #ff4d4f;
  background-color: rgba(255, 255, 255, 0.8);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 温馨提示样式 */
.tip-text {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  margin-top: 10px;
}

/* 自定义上传按钮内部内容（图标+文字） */
.upload-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 148px;
}

/* 上传按钮文字 */
.upload-text {
  font-size: 14px;
  color: #606266;
  width: 100%;
  line-height: normal;
  margin-top: 5px;
}

/* 预览弹窗图片样式 */
.preview-img {
  width: 100%;
  height: auto;
  max-height: 600px;
  object-fit: contain;
}
</style>
